import number_format from 'locutus/php/strings/number_format';

export default {
    name: 'adivare-list-item-content',
    props: {
      rental: {
        type: Object,
        required: true
      },
      index: {
        type: Number,
        required: true
      }
    },
    computed: {
        favoriteable: function() {
            return this.rental.status === this.houseStatuses.under_option || this.rental.status === this.houseStatuses.rented_out;
        },
        houseStatuses () { return this.$store.state.houseStatuses; },
        showWatermarkOverlay () {
            if (this.rental.hasWatermarkedImages && !this.$store.state.userIsPremium) {
                return true;
            }
            return false;
        },
        truncatedDescription: function () {
            if (this.rental.description == null || this.rental.originalDescription == null) {
                return null;
            }

            let description = this.rental.description,
                url = this.rental.contactUrl,
                tooltipText = this.$t('messages_nl.contact.tooltip.register');

            if (null !== this.$store.state.userId) {
                url = this.rental.upgradeUrl;
                tooltipText = this.$t('messages_nl.contact.tooltip.premium');
                if (this.$store.state.userIsPremium) {
                    description = this.rental.originalDescription;
                }
            }

            if (this.$store.state.userIsPremium) {
                return description;
            }

            // Remove link to contact page when rental is rented out and description contains agent
            let blurredAgentDesc = '<a href="'+url+'" class="no-link"><span class="text-blurred" data-toggle="tooltip" data-placement="top" data-title="'+tooltipText+'">***</span></a>';
            if (this.rental.status === this.houseStatuses.rented_out) {
                blurredAgentDesc = '<span class="no-link"><span class="text-blurred">***</span></span>';
            } 
            return description.replace(/\*{3,8}/g, blurredAgentDesc);

        },
        formattedSpace: function () {
            if (0 === this.rental.floorspace) {
                return '-';
            }

            return this.rental.floorspace + ' m2';
        },
        formattedRooms: function () {
            if (0 === this.rental.rooms) {
                return '-';
            }

            return this.rental.rooms;
        },
        formattedPrice: function () {
            return '€ ' + number_format(this.rental.price, 0, ',', '.');
        },
        formattedPostalCode: function () {
            return this.rental.postcode.replace(/(\d{4})([A-Z]{2})/, '$1 $2');
        },
        formattedLocation: function () {
            if (this.rental.isBlurred) {
                const postalCodePlaceholder = this.$t('messages_nl.search.greenlist.placeholders.postalCode');
                const neighborhoodPlaceholder = this.$t('messages_nl.search.greenlist.placeholders.neighborhood');
                return `${postalCodePlaceholder} ${this.rental.city} (${neighborhoodPlaceholder})`;
            }
            let location = `${this.formattedPostalCode} ${this.rental.city}`;
            if (this.rental.neighborhood) location += ` (${this.rental.neighborhood})`;
            return location;
        }
    },
}
